import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { FieldRow, FieldValue } from "@/components/feature/FieldRow";


const Room = () => {
  const [room, setRoom] = useState("");
  const dispatch = useDispatch();

  const setRoomState = (roomName, roomEmail) => {
    setRoom(roomName);

    dispatch({
      type: "SET_APPOINTMENT_DATA",
      payload: { room: roomName },
    });
  };

  const getRoom = () => {
    Office.context.mailbox.item.enhancedLocation.getAsync((result) => {
      if (result.status !== Office.AsyncResultStatus.Succeeded) {
        console.error(`Failed to get locations. Error message: ${result.error.message}`);
        return;
      }

      const places = result.value;
      if (places && places.length > 0) {
        const rooms = places.filter(
          (place) => place.locationIdentifier.type === Office.MailboxEnums.LocationType.Room,
        );
        const others = places.filter(
          (place) => place.locationIdentifier.type !== Office.MailboxEnums.LocationType.Room,
        );
        const sorted = [...rooms, ...others];
        const displayName = sorted.map((p) => p.displayName).join(", ");
        setRoomState(displayName, "");
      } else {
        setRoomState("", "");
      }
    });
  };

  useEffect(() => {
    getRoom();

    const { addHandlerAsync, removeHandlerAsync } = Office.context.mailbox.item;
    const { EnhancedLocationsChanged } = Office.EventType;

    if (Office.context.mailbox.item) {
      addHandlerAsync(EnhancedLocationsChanged, getRoom);

      return () => {
        removeHandlerAsync(EnhancedLocationsChanged, getRoom);
      };
    }
    return () => {};
  }, []);

  return room ? (
    <FieldRow label="Raum">
      <FieldValue>{room}</FieldValue>
    </FieldRow>
  ) : null;
};

export default Room;
